/* tslint:disable:member-ordering */
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: 'input',
    standalone: false
})
export class SelectOnFocusDirective {
  constructor(private el: ElementRef) {}

  @HostListener('focus') onFocus() {
    this.el.nativeElement.select();
  }
}
